<template>
  <div class="basic">
    <Form ref="formInline" :model="formInline" style="width: 100%" :rules="ruleInline" label-position="top"
      @on-validate="getvalidate">
      <div class="basic-header">
        <p>- Company Profile -</p>
      </div>
      <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
        <!-- 公司名称 -->
        <div class="basic-name">
          <Row :gutter="40">
            <Col span="12">
            <FormItem label="Company" prop="companyNameEn">
              <Input type="text" placeholder="Please enter the Company" maxlength="400"
                v-model="formInline.companyNameEn" />
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="Fax">
              <Row :gutter="10">
                <Col span="8">
                <Input type="text" placeholder="Country Code" v-model="fax.country" />
                </Col>
                <Col span="8">
                <Input type="text" placeholder="Area Code" v-model="fax.area" />
                </Col>
                <Col span="8">
                <Input type="text" placeholder="Fax No." v-model="fax.no" />
                </Col>
              </Row>
              <p style="line-height: 1;font-size: 12px;color: #808080; position: relative;top: 8px;">
                example ：+86-10-6343 0880
              </p>
            </FormItem>
            </Col>
          </Row>
        </div>

        <!-- 公司地址 -->
        <div class="basic-address">
          <Row :gutter="40">
            <Col span="12">
            <FormItem label="Country/District" required prop="addresss">
              <mFormAddress v-model="formInline.addresss" @change="validAddresss"></mFormAddress>
            </FormItem>
            </Col>

            <Col span="12">
            <Row :gutter="20">
              <Col span="12">
              <FormItem prop="postcode" label="Post code">
                <Input type="text" placeholder="Please enter the postal Code" v-model="formInline.postcode" />
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem prop="address" label="Address">
                <Input type="text" placeholder="Please enter the address" v-model="formInline.address" />
              </FormItem>
              </Col>
            </Row>
            </Col>
          </Row>
        </div>

        <!-- 公司名称 -->
        <div class="basic-name">
          <Row :gutter="40">
            <Col span="12">
            <FormItem label="Website" prop="website">
              <Input type="text" placeholder="Please enter the website" v-model="formInline.website"
                :rules="ruleInline.website" />
            </FormItem>
            </Col>
          </Row>
        </div>
      </div>

      <!-- 展会联系人 -->
      <div class="basic-link">
        <FormItem label="Contact Person" required> </FormItem>
      </div>
      <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
        <div class="basic-links">
          <Row :gutter="40">
            <Col span="12">
            <FormItem label="Name" prop="linkMan">
              <Input type="text" placeholder="Please enter the name" v-model="formInline.linkMan" />
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="Position" prop="linkTitle">
              <Input type="text" placeholder="Please enter the position" v-model="formInline.linkTitle" />
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="Phone" prop="linkMob">
              <Input type="text" placeholder="Please enter the phone" v-model="formInline.linkMob" />
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem label="E-mail" prop="linkEmail">
              <Input type="text" placeholder="Please enter the E-mail" v-model="formInline.linkEmail" />
            </FormItem>
            </Col>
          </Row>
          <Row :gutter="40">
            <Col span="12">
            <FormItem label="Tel" prop="linkTelephone" required>
              <Row :gutter="10">
                <Col span="8">
                <Input type="text" placeholder="Country Code" v-model="tel.country" />
                </Col>
                <Col span="8">
                <Input type="text" placeholder="Area Code" v-model="tel.area" />
                </Col>
                <Col span="8">
                <Input type="text" placeholder="Telephone No." v-model="tel.no" />
                </Col>
              </Row>
              <p style="line-height: 1;font-size: 12px;color: #808080; position: relative;top: 8px;">
                example ：+86-10-6343 0880
              </p>
            </FormItem>

            </Col>
          </Row>
        </div>
      </div>

    </Form>
  </div>
</template>

<script>
import mFormAddress from "@components/m-form/m-form-address-en.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data() {
    const that = this;
    const websiteValid = (rule, value, callback) => {
      if (value) {
        // if (/(http|https):\/\/([\w.]+\/?)\S*/.test(value)) {
        callback();
        // } else {
        //   callback("website format is not correct!");
        // }
      } else {
        callback();
      }
    };
    // 判断英文
    const enValid = (rule, value, callback) => {
      //   if (/^(?!\s*$)[A-Za-z0-9._\-\&\(\)\（）\s-]+$/.test(value)) {
      callback();
      //   } else {
      //     callback(new Error('英文名称格式有误'));
      //   }
    };
    const companyAddressValid = (rule, value, callback) => {
      if (that.formInline.addresss.country && that.formInline.addresss.country === 'China') { // China 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          callback(new Error('province is empty'));
        } else if (!that.formInline.addresss.city) {
          callback(new Error('city is empty'));
        } else {
          callback();
        }
      } else {
        if (that.formInline.addresss.country) {
          callback();
        } else {
          callback(new Error('Country/District is empty'));
        }
      }
    };
    const telephoneValid = (rule, value, callback) => {
      if (!that.tel.country) {
        callback(new Error('Country Code is empty'));
      } else if (!that.tel.area) {
        callback(new Error('Area Code is empty'));
      } else if (!that.tel.no) {
        callback(new Error('Area Code is empty'));
      } else {
        callback();
      }
    };
    const faxValid = (rule, value, callback) => {
      if (!that.fax.country) {
        callback(new Error('Country Code is empty'));
      } else if (!that.fax.area) {
        callback(new Error('Area Code is empty'));
      } else if (!that.fax.no) {
        callback(new Error('Telephone No. is empty'));
      } else {
        callback();
      }
    };
    const validEmail = (rule, value, callback) => {
      if (value) {
        if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
          callback();
        } else {
          callback("E-mail format is not correct!");
        }
      } else {
        callback();
      }
    };
    return {
      loading: false,
      fax: {
        country: '',
        area: '',
        no: '',
      },
      tel: {
        country: '',
        area: '',
        no: '',
      },
      formInline: {
        // 企业基本信息
        linkFax: "",
        companyName: "", // 公司名称
        companyNameEn: "",// 公司Company
        address: "", // address
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县 
        },
        postcode: "",
        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkTelephone: "",
        linkEmail: "",
        linkCode: "", // 区号
        linkMob: "", // 电话号码 
        website: "", // 电话号码 
      },
      formInline0: {
        // 企业基本信息
        linkFax: "",
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameEn: "lianzhan",// 公司Company
        address: "金沙江西路1555路慧创国际16号2层", // address
        addresss: {
          country: "China", // 国家
          province: "Beijing", // 省份
          city: "Dongcheng", // 城市
          county: "", // 区县 
        },
        postcode: "201803",

        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "13122959676",
        linkEmail: "2624006658@qq.com",
        linkCode: "021", // 区号
        linkTelephone: "8888888", // 电话号码 
        website: "http://192.168.1.183:8081/ex-register-en/register", // 电话号码 
      },
      ruleInline: {
        // 企业基本信息
        companyNameEn: [
          { required: true, message: "Please enter the company name", trigger: "blur" },
          //   { validator: enValid, message: "company name format is not correct!", trigger: "blur" }
        ],
        website: [
          { validator: websiteValid, trigger: "blur" }
        ],
        postcode: [{ required: true, message: "Please enter the postal code", trigger: "blur" }],
        addresss: [{
          required: true,
          validator: companyAddressValid, trigger: "change"
        }],
        linkTelephone: [{
          required: true,
          validator: telephoneValid, trigger: "blur"
        }],
        // Fax: [{
        //   required: true,
        //   validator: faxValid, trigger: "blur"
        // }],
        address: [
          { required: true, message: "Please enter the address", trigger: "blur" },
        ],

        // 展会联系人
        linkMan: [{ required: true, message: "Please enter the name", trigger: "blur" }],
        linkTitle: [{ required: true, message: "Please enter the position", trigger: "blur" }],
        linkMob: [
          {
            required: true,
            message: "Please enter the phone",
            trigger: "blur",
          },
          //   {
          //     validator: (rule, value, callback) => {
          //       if (!value) {
          //         callback('Please enter the phone');
          //       } else if (/^[1][0-9]{10}$/.test(value)) {
          //         callback();
          //       } else {
          //         callback('Phone format is not correct!');
          //       }
          //     }, trigger: "blur"
          //   }
        ],
        linkEmail: [
          { required: true, message: 'Please enter the E-mail', trigger: 'blur' },
          { validator: validEmail, trigger: 'blur' }
        ],
      },
      defaultList: [],
      uploadList: [],
      uploadName: "",


      validateList: [],

      countryList: [],
      provinceArr: [],
      citiesArr: [],
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
  },
  async created() {
    let opt = {
      exhibitionId: 'd40c08b7-29b0-450a-b5b5-0d9b27756137',
      type: 'PCEN',
    }
    let opt1 = {
      exhibitionId: 'd607a2a8-83cd-430d-9ab7-0b8e8aabb73a',
      type: 'PCEN',
    }
    let res = await this.getBackeryTotal(opt);
    let res1 = await this.getBackeryTotal(opt1);
  },
  methods: {
    ...mapActions({
      getCityByParentId: "exhibitionModule/getCityByParentId",
      getBackeryTotal: "registerdModule/getBackeryTotal",

      addApplyCompany: "addApplyCompany",
      editApplyCompany: "editApplyCompany",
    }),
    getvalidate(prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
          error: error,
        };
        this.validateList.push(opt);
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm('formInline');

      let errTxt = '';
      if (!valid) {
        errTxt = this.validateList[0] ? this.validateList[0].error : 'Errors in forms submitted, please re-submit.'
      }
      if (errTxt) {
        this.$Message.error(errTxt);
        this.validateList = []
      }
      let formValue = {
        linkFax: `${this.fax.country || ''}${this.fax.area || ''}${this.fax.no || ''}`,
        companyName: form.companyNameEn, // 公司名称
        companyNameEn: form.companyNameEn,// 公司Company
        address: form.address, // address 
        country: form.addresss.country,
        province: form.addresss.province,
        city: form.addresss.city,
        postcode: form.postcode,
        // 展会联系人
        linkMan: form.linkMan,
        linkTitle: form.linkTitle,
        linkMob: form.linkMob,
        linkEmail: form.linkEmail,
        linkCode: form.linkCode, // 区号
        linkTelephone: `${this.tel.country || ''}${this.tel.area || ''}${this.tel.no || ''}`, // 电话号码  
        website: form.website, // 区号
      }
      let tel = {
        fax: { countryCode: this.fax.country || '', areaCode: this.fax.area || '', code: this.fax.no || '', subcode: '' },
        tels: { countryCode: this.tel.country || '', areaCode: this.tel.area || '', code: this.tel.no || '', subcode: '' },
      }
      return new Promise((resolve, reject) => {
        resolve({ valid: valid, form: formValue, tel: tel })
      });
    },
    validAddresss() {
      // this.$refs['formInline'].validateField('addresss', (valid) => {
      //   console.log("addresss", valid);
      // });
    },
  },
};
</script>

<style scoped lang='scss'>
.basic {
  /deep/ {
    .ivu-checkbox-checked .ivu-checkbox-inner {
      border-color: #b10042;
      background-color: #b10042;
    }

    .ivu-upload-select {
      display: flex;
    }

    .ivu-radio-checked .ivu-radio-inner {
      border-color: #b10042 !important;
    }

    .ivu-radio-inner:after {
      background-color: #b10042;
    }

    .ivu-switch-checked {
      border-color: #b10042;
      background-color: #b10042;
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #b10042;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 30px 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 30px 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 30px 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 30px 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 180px;
    height: 32px;
    background-color: #fff;
    text-align: center;
    cursor: pointer;
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      .txt1 {
        width: 200px;
        display: inline-block;
        height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #515a6e !important;
      }

      span {
        color: #b10042;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}
</style>
